__turbopack_context__.v({
  "deliveryPanelContainer": "DeliveryPanelContainer-module__WBapAa__deliveryPanelContainer",
});
